import { registerControllers } from 'stimulus-vite-helpers'
import TextareaAutogrow from 'stimulus-textarea-autogrow'
import ClipboardController from 'jet_ui_js/clipboard_controller'
import DrawerController from 'jet_ui_js/drawer_controller'
import DrawersController from 'jet_ui_js/drawers_controller'
import DropdownController from 'jet_ui_js/dropdown_controller'
import FlashController from 'jet_ui_js/flash_controller'
import ModalController from 'jet_ui_js/modal_controller'
import ModalsController from 'jet_ui_js/modals_controller'
import PasswordVisibility from '@stimulus-components/password-visibility'
import PopoverController from 'jet_ui_js/popover_controller'
import TooltipController from 'jet_ui_js/tooltip_controller'
import TurboConfirmController from 'jet_ui_js/turbo_confirm_controller'
import CharacterCounter from '@stimulus-components/character-counter'

import { stimulus } from '~/init'

stimulus.register('textarea-autogrow', TextareaAutogrow)
stimulus.register('clipboard', ClipboardController)
stimulus.register('drawer', DrawerController)
stimulus.register('drawers', DrawersController)
stimulus.register('dropdown', DropdownController)
stimulus.register('flash', FlashController)
stimulus.register('modal', ModalController)
stimulus.register('modals', ModalsController)
stimulus.register('password-visibility', PasswordVisibility)
stimulus.register('popover', PopoverController)
stimulus.register('tooltip', TooltipController)
stimulus.register('turbo-confirm', TurboConfirmController)
stimulus.register('character-counter', CharacterCounter)

const controllers = import.meta.glob('./**/*_controller.js', { eager: true })
registerControllers(stimulus, controllers)
